import { http, HttpResponse } from 'msw';

// A stub OAuth URL — only the path and `client_id` query param matter; `parseOauthUrl`
// extracts them so AuthenticationPanelButton can render the "Connect" button. Clicking
// the button in a story won't complete a real OAuth flow, but it surfaces the affordance.
const STUB_GUSTO_OAUTH_URI =
    'https://api.gusto.com/oauth/authorize?client_id=storybook-client-id&scope=app&state=gusto&response_type=code';

interface ProviderConnection {
    connected: boolean;
    uri: string;
    organization_name?: string | null;
}

type ProviderKey = 'gusto' | 'hurdlr';

interface OAuthResponse {
    connections: Record<ProviderKey, ProviderConnection>;
}

type OAuthOverrides = Partial<Record<ProviderKey, Partial<ProviderConnection>>>;

const disconnectedConnection = (uri = ''): ProviderConnection => ({
    connected: false,
    uri,
    organization_name: null,
});

/**
 * Build an `/oauth/` response. Defaults to all providers disconnected with a usable
 * Gusto Connect-button affordance. Stories override individual providers as needed
 * (e.g. `buildOAuthResponse({ gusto: { connected: true, organization_name: 'Acme Co' } })`).
 */
export const buildOAuthResponse = (overrides: OAuthOverrides = {}): OAuthResponse => ({
    connections: {
        gusto: { ...disconnectedConnection(STUB_GUSTO_OAUTH_URI), ...overrides.gusto },
        hurdlr: { ...disconnectedConnection(), ...overrides.hurdlr },
    },
});

export default {
    'oauth/getConnections': http.get('*/oauth/', () => HttpResponse.json(buildOAuthResponse())),
};
